import { ActivityPlanNotification } from './activity-plan-notification-class'
import { activityPlanDefaultNotificationDataInjector } from './activty-plan-default-notification-builder'

const TYPES_OF_ACTIVITY_PLAN_NOTIFICATIONS = {}

const ACTIVITY_PLAN_NOTIFICATION_DATA_INJECTORS = {}

export function activityPlanFallBackNotificationData(notificationData, variablesForUse = {}) {
  const activityPlanNotificationData = new ActivityPlanNotification({
    notificationData,
    variablesForUse,
  })
  const dataInjector =
    ACTIVITY_PLAN_NOTIFICATION_DATA_INJECTORS?.[activityPlanNotificationData.subType] ||
    activityPlanDefaultNotificationDataInjector

  dataInjector(activityPlanNotificationData)

  return activityPlanNotificationData
}
